export default __webpack_public_path__ + "static/media/Ostali 6.624363af.jpg";